import { render, staticRenderFns } from "./crateBookings.vue?vue&type=template&id=b66faffe"
import script from "./crateBookings.vue?vue&type=script&lang=js"
export * from "./crateBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b66faffe')) {
      api.createRecord('b66faffe', component.options)
    } else {
      api.reload('b66faffe', component.options)
    }
    module.hot.accept("./crateBookings.vue?vue&type=template&id=b66faffe", function () {
      api.rerender('b66faffe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Production/crateBookings.vue"
export default component.exports